import $ from 'jquery';

// Toggle the `checked` attribute of many other elements.
// Master checkbox should have data-toggle-target="<jquery selector>"
//
// Eg: <input type="checkbox" data-toggle-target=".other-checkboxes"/>

const toggleAll = function() {
  const target_string = $(this).data('toggle-target');
  $(target_string)
    .prop('checked', this.checked)
    .trigger('input');
};

$(() => {
  if (!$('[data-toggle-target]').length) return;
  $('body').on('change', '[data-toggle-target]', toggleAll);
});
